import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    getRes: null,
    postRes: null,
    uploadRes: null,
};

const slice = createSlice({
    name: 'patientConsent',
    initialState,
    reducers: {
        getPatientConsentRequest: (state) => {
            state.loading = true;
        },
        getPatientConsentSuccess: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        getPatientConsentFailure: (state, action) => {
            state.loading = false;
            state.getRes = action.payload;
        },
        postPatientConsentRequest: (state) => {
            state.loading = true;
        },
        postPatientConsentSuccess: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        postPatientConsentFailure: (state, action) => {
            state.loading = false;
            state.postRes = action.payload;
        },
        resetPostPatientConsent: (state) => {
            state.postRes = null;
        },
        uploadPatientConsentRequest: (state) => {
            state.loading = true;
        },
        uploadPatientConsentSuccess: (state, action) => {
            state.loading = false;
            state.uploadRes = action.payload;
        },
        uploadPatientConsentFailure: (state, action) => {
            state.loading = false;
            state.uploadRes = action.payload;
        },
        resetUploadPatientConsent: (state) => {
            state.uploadRes = null;
        }
    }
});

export const {
    getPatientConsentRequest, getPatientConsentSuccess, getPatientConsentFailure,
    postPatientConsentRequest, postPatientConsentSuccess, postPatientConsentFailure, resetPostPatientConsent,
    uploadPatientConsentRequest, uploadPatientConsentSuccess, uploadPatientConsentFailure, resetUploadPatientConsent,
} = slice.actions;

export default slice.reducer;
